import { createContext, useContext, useState, useCallback } from 'react';
import { createPortal } from 'react-dom';
import './Toast.css';

const ToastContext = createContext(null);

let idSeq = 0;

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const remove = useCallback((id) => {
    setToasts((ts) => ts.filter((t) => t.id !== id));
  }, []);

  const notify = useCallback((message, { tone = 'success', title, duration = 4000 } = {}) => {
    const id = ++idSeq;
    setToasts((ts) => [...ts, { id, message, tone, title }]);
    if (duration) setTimeout(() => remove(id), duration);
    return id;
  }, [remove]);

  return (
    <ToastContext.Provider value={{ notify }}>
      {children}
      {createPortal(
        <div className="toast-stack" aria-live="polite" aria-atomic="false">
          {toasts.map((t) => (
            <div key={t.id} className={`toast toast-${t.tone}`} role="status">
              <div className="toast-body">
                {t.title && <strong>{t.title}</strong>}
                {t.title && <br />}
                <span>{t.message}</span>
              </div>
              <button className="toast-close" onClick={() => remove(t.id)} aria-label="Cerrar notificación">×</button>
            </div>
          ))}
        </div>,
        document.body
      )}
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast debe usarse dentro de <ToastProvider>');
  return ctx;
}